import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=49f565d6&scoped=true&"
import script from "./Payments.vue?vue&type=script&lang=js&"
export * from "./Payments.vue?vue&type=script&lang=js&"
import style0 from "./Payments.vue?vue&type=style&index=0&id=49f565d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f565d6",
  null
  
)

export default component.exports